import { cn } from "@/lib/utils"

/**
 * The page-header trace art: a chromatogram peak running into a specimen tube.
 *
 * Drawn in `currentColor` at low opacity so it inherits whatever ink the
 * header sets and therefore follows the tenant's brand and the mode without
 * knowing about either. No fills, no hardcoded colours, no second theme to
 * maintain.
 *
 * ⭐ THIS IS MOUNTED AS ITS OWN FLEX CELL, NEVER ABSOLUTELY POSITIONED.
 * The obvious way to place header art is `absolute inset-y-0 right-0`, and on
 * a crowded header it then draws straight THROUGH the action buttons — which
 * reads as "the buttons look broken", not as "the decoration is misplaced".
 * Given a real cell (`flex-1 basis-0 min-w-0 overflow-hidden`) it crops when
 * the header is busy and can never underlap a control.
 */
export function LabTrace({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 420 64"
      fill="none"
      aria-hidden="true"
      focusable="false"
      preserveAspectRatio="xMidYMid meet"
      className={cn("h-12 w-full", className)}
    >
      {/* baseline */}
      <path
        d="M0 46 H120"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        opacity="0.5"
      />
      {/* the trace: two small peaks, one tall one, settling back to baseline */}
      <path
        d="M120 46 L142 40 L152 46 L170 30 L182 46 L200 8 L214 46 L236 38 L246 46 H300"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* a specimen tube the trace runs into */}
      <path
        d="M312 14 H340 M316 14 V44 a10 10 0 0 0 20 0 V14"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M316 34 a10 10 0 0 0 20 0" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      {/* two drops, to the right of the tube */}
      <circle cx="366" cy="26" r="3" stroke="currentColor" strokeWidth="1.6" />
      <circle cx="382" cy="40" r="2" stroke="currentColor" strokeWidth="1.4" opacity="0.7" />
    </svg>
  )
}

export default LabTrace
